import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

const reserveHistoryService = (action: any) => {
  return {
    getReserveHistorys: () =>
      apiClient.get(`${API_BASE_ADDRESS}/visitor/yoyaku/reserve-historys`, {
        params: {
          visitor_id: action.visitorId,
          birthday: action.birthday,
          telephone: action.telephone,
          history_id: action.historyId,
          sex: action.sex,
        },
      }),
    putCancelReserve: () =>
      apiClient.put(`${API_BASE_ADDRESS}/visitor/yoyaku/cancel-reserve`, {
        contents_id: action.contentsId,
        schedule_id: action.scheduleId,
      }),
  };
};

export default reserveHistoryService;
